import SideFilter from './components/SideFilter/SideFilter'
import Calendar from './components/Calendar/Calendar'
import { SidePage } from '@components/templates'
import { useContextSelector } from 'use-context-selector'
import { ScheduleContext } from './context'
import { Helmet } from 'react-helmet'

export default function ScheduleView() {
  const slim = useContextSelector(ScheduleContext, (context) => context.slim)

  return (
    <>
      <Helmet>
        <title>Nomos - Agenda</title>
      </Helmet>
      <SidePage
        id="schedule-page"
        data-testid="schedule-page"
        sideComponent={<SideFilter />}
        leftVisible={!slim}
      >
        <Calendar />
      </SidePage>
    </>
  )
}
